import type { Migrants, World } from '../types';
import { stockStream } from '../streams';
import { openingRightWhales, stepNorthAtlanticRightWhales } from './rightwhales';
import { openingBlueMarlin, stepPacificBlueMarlin } from './marlin';
import { openingLeatherbacks, stepWestPacificLeatherbacks } from './leatherback';
import { openingGrayWhales, stepEasternGrayWhales } from './graywhales';

/**
 * Step 3 of the tick, the animals, after every sanctuary's (M107): the
 * populations of no sanctuary, the North Atlantic right whales, then the
 * Pacific blue marlin (M108), then the western Pacific leatherbacks (M111),
 * then the eastern North Pacific gray whales (M112), each on its own stream
 * of the day (a test hands in its own as `streamOf`).
 */
export function stepMigrants(world: World, streamOf: typeof stockStream = stockStream): void {
  stepNorthAtlanticRightWhales(world, streamOf);
  stepPacificBlueMarlin(world, streamOf);
  stepWestPacificLeatherbacks(world, streamOf);
  stepEasternGrayWhales(world, streamOf);
}

/** The populations of no sanctuary as a world opens on a day. */
export function openingMigrants(epochDay: number): Migrants {
  return { rightWhale: openingRightWhales(epochDay), blueMarlin: openingBlueMarlin(epochDay), leatherback: openingLeatherbacks(epochDay), grayWhale: openingGrayWhales(epochDay) };
}
